import {
  Component,
  EventEmitter,
  OnInit,
  ViewChild
} from '@angular/core';
import {
  Failure,
  NetscopeApiService,
  Success,
  Response
} from '@app/services/netscope-api.service';
import {
  ActivatedRoute,
  Router
} from '@angular/router';
import {
  of
} from 'rxjs';
import {
  ClrDatagridStringFilterInterface
} from "@clr/angular";
import {
  HeatmapComboboxComponent
} from "@app/netscope/netscope-heatmap-viewer/heatmap-combobox/heatmap-combobox.component";
import {
  HeatmapHighchartsHeatmapComponent
} from "@app/netscope/netscope-heatmap-viewer/heatmap-highcharts-heatmap/heatmap-highcharts-heatmap.component";
import {TranslocoService} from "@ngneat/transloco";
import {NetscopeUiService} from "@app/services/netscope-ui.service";
import {AsnEntry, CountryEntry, DuckDbResourceObject, FlowDetail, FlowRessourceObject, InfrastructureVersion, TemporalParameter, HeatmapFlowDetail} from "@app/netscope/model/data-models";
import {EChartsOption} from "echarts";
import {NetscopeUtils} from "@app/netscope/netscope-utils";


@Component({
  standalone: false,
  selector: 'app-netscope-heatmap-viewer-clusters',
  templateUrl: './netscope-heatmap-viewer.component.html',
  styleUrls: ['./netscope-heatmap-viewer.component.css']
})
export class NetscopeHeatmapViewerComponent implements OnInit {

  externalIps = undefined;
  isLoading = false;
  heatmapIsLoading = false;
  failureMode = false;

  resourceUuidToObjectsIndex = {};
  heatmapSourceResources = [];
  heatmapLinkedResources = [];
  selectedResources1: any[] = [];
  selectedResources2: any[] = [];
  flowDetails;
  displayedTime = "";
  selectedTimestamp: number = 0;
  selectedTimeResolution = "";
  bidirectionalFlows = "yes";
  directionMode: "bidirectional" | "unidirectional" | "all" = "bidirectional";

  combobox1IsDisabled = true;
  combobox2IsDisabled = true;
  combobox2IsLoading = false;

  temporalParameter: TemporalParameter;

  @ViewChild('vm2Combobox') vm2ComboboxRef: HeatmapComboboxComponent;

  @ViewChild('temporalSelectionHeatMap')
  temporalSelectionHeatMap: HeatmapHighchartsHeatmapComponent;

  sidePanelFlows: FlowDetail[] = [];
  sidePanelOpened: boolean = false;
  sidePanelTitle: string = "";
  sidePanelResourceUuid: string = "";
  sidePanelIsAlreadyFocused: boolean = false;
  sidePanelProtocolsOptions: EChartsOption;
  sidePanelOriginsOptions: EChartsOption;

  timeResolutionRadioButtonValue : "daily" | "hourly" = "daily";

  resourceSelectionChanged = new EventEmitter();
  clickOnTimeSlotEmitter = new EventEmitter();
  loadingStateUpdateEmitter = new EventEmitter();

  style = getComputedStyle(document.body);
  isDarkMode: boolean = false;

  constructor(private netscopeService: NetscopeApiService, private activatedRouter: ActivatedRoute,
              private route: Router, public translocoService: TranslocoService,
              private netscopeUiService: NetscopeUiService) {
  }

  ngOnInit(): void {

    this.netscopeUiService.setViewLabel("heatmap_viewer.name");
    this.netscopeUiService.setIconShape("heat-map");

    this.combobox1IsDisabled = true;

    this.netscopeUiService.temporalParametersSubject.subscribe((newTemporalParameters) => {
      this.temporalParameter = newTemporalParameters;
    })

    this.activatedRouter.queryParams.subscribe((queryParams) => {

      // Check if a start_time parameter has been specified
      let start_time_str_value = queryParams["start_time"];
      let time_resolution_str_value = queryParams["time_resolution"];
      if (start_time_str_value !== undefined && time_resolution_str_value !== undefined) {
        function tryToSetDateOnHeatmap(maxRemainingAttempt = 5) {
        }

        tryToSetDateOnHeatmap();
      }

      const externalIpsObservable = this.netscopeService.getExternalIps();

      externalIpsObservable.subscribe((response: Response<any>) => {
        if (response instanceof Success) {
          this.externalIps = response.element.external_ips;
        }
        this.netscopeService.getLastInfrastructureVersion().subscribe((infrastructureVersionResponse: Response<any>) => {

          let infrastructureVersion;

          if (infrastructureVersionResponse instanceof Success) {
            infrastructureVersion = infrastructureVersionResponse.element;
          } else {
            this.failureMode = true;
            this.isLoading = false;
            return;
          }

          this.buildResourceUuidToObjectIndex(infrastructureVersion);

          this.activatedRouter.params.subscribe((params) => {
            let resource_uuid_1_parts = params["resource_uuid_1"].split("_");
            let resource_uuid_2_parts = params["resource_uuid_2"].split("_");

            let resource_uuid_1 = resource_uuid_1_parts[0];
            let resource_uuid_2 = resource_uuid_2_parts[0];

            let resource_address_1 = "";
            let resource_address_2 = "";

            if (resource_uuid_1_parts.length >= 2) {
              resource_address_1 = resource_uuid_1_parts[1];
            }

            if (resource_uuid_2_parts.length >= 2) {
              resource_address_2 = resource_uuid_2_parts[1];
            }

            // Fix for when source or destination are unknown Ips
            if (resource_uuid_1 !== undefined && !this.resourceUuidToObjectsIndex[resource_uuid_1]) {
              let ressource1Type = "unknown_ip";
              if (resource_uuid_1.indexOf("vim.UnknownIpaddress:") !== -1) {
              }
              if (resource_uuid_1.indexOf("vim.ExternalIpaddress:") !== -1) {
                ressource1Type = "external_ip";
              }
              this.resourceUuidToObjectsIndex[resource_uuid_1] = {
                shortUuid: resource_uuid_1.split(":")[1],
                uuid: resource_uuid_1,
                name: resource_address_1,
                resourceType: ressource1Type
              };
            }
            if (resource_uuid_2 !== undefined && !this.resourceUuidToObjectsIndex[resource_uuid_2]) {
              let ressource2Type = "unknown_ip";
              if (resource_uuid_2.indexOf("vim.UnknownIpaddress:") !== -1) {
              }
              if (resource_uuid_2.indexOf("vim.ExternalIpaddress:") !== -1) {
                ressource2Type = "external_ip";
              }
              this.resourceUuidToObjectsIndex[resource_uuid_2] = {
                shortUuid: resource_uuid_2.split(":")[1],
                uuid: resource_uuid_2,
                name: resource_address_2,
                resourceType: ressource2Type
              };
            }

            if (resource_uuid_1 !== undefined && resource_uuid_2 !== undefined) {
              this.selectedResources1 = [this.resourceUuidToObjectsIndex[resource_uuid_1]]
              this.selectedResources2 = [this.resourceUuidToObjectsIndex[resource_uuid_2]]
            }
            this.reloadData();
          });
        });
      });
    })
    this.reloadData();

    window.onresize = () => {
      if (this.externalIps !== undefined) {
        this.reloadUi("*");
      }
    };

    // this.licenceService.licenseInfo.subscribe(licenceInfo => {
    //     if (environment.production) {
    //         // Check second bit to be different from 0
    //         this.isNetscopeLicenceEnabled = (licenceInfo.moduleslicense & (1 << 1)) !== 0;
    //     } else {
    //         this.isNetscopeLicenceEnabled = true;
    //     }
    //
    //     if (this.isNetscopeLicenceEnabled) {
    //         this.reloadData();
    //     }
    // });

    this.route.events.subscribe((event) => {
      this.ngOnDestroy();
    });

    this.clickOnTimeSlotEmitter.subscribe((event) => {
      this.selectedTimestamp = event[0];
      this.selectedTimeResolution = event[2];
      this.loadFlows(event[0], event[2]);
      this.displayedTime = event[1];
    });

    this.loadingStateUpdateEmitter.subscribe((event) => {
      this.heatmapIsLoading = event;
    })

    this.netscopeUiService.darkModeStatusSubject.subscribe((darkModeStatus: boolean) => {
      this.isDarkMode = darkModeStatus;
      this.reloadUi("*");
    })
  }

  vm1SelectionChanged = () => {
    this.combobox2IsDisabled = true;
    this.combobox2IsLoading = true;
    this.selectedResources2 = [];

    let selectedResourceUuid = this.selectedResources1[0].uuid;

    this.resourceSelectionChanged.emit({
      "reloadData": true
    });

    this.netscopeService.heatmapLinkedResources(selectedResourceUuid).subscribe((response) => {

      if (response instanceof Failure) {
        this.failureMode = true;
        this.isLoading = false;
        return;
      }

      if (response instanceof Success) {

        this.heatmapLinkedResources = response.element;

        setTimeout(() => {
          // @ts-ignore
          this.fetchVms2('', this.vm2ComboboxRef);
        }, 100);
        this.reloadUi('*');
      }

    })
  }

  vm2SelectionChanged = () => {
    // this.displayHeatmap();
    this.resourceSelectionChanged.emit({
      "reloadData": true
    });
  }

  directionChanged = () => {
    this.resourceSelectionChanged.emit({
      "reloadData": true,
      "bidirectional": this.bidirectionalFlows === "yes",
      "directionMode": this.directionMode
    });
  }

  fetchVms1 = (filter = '', combobox: HeatmapComboboxComponent) => {
    combobox.loadingResources = true;

    let resources = this.heatmapSourceResources
      .map((e) => this.resourceUuidToObjectsIndex[e])
      .filter((o) => o !== undefined)
      .filter((o) => o.uuid.indexOf(filter) !== 1 || o.name.indexOf(filter) !== -1);

    combobox.asyncResources$ = of(resources);
    combobox.loadingResources = false;
    this.flowDetails = undefined;
  }

  fetchVms2 = (filter = 'second_vm', combobox: HeatmapComboboxComponent) => {
    combobox.loadingResources = true;

    let resources = this.heatmapLinkedResources
      .map((e) => this.resourceUuidToObjectsIndex[e])
      .filter((o) => o !== undefined)
      .filter((o) => o.uuid.indexOf(filter) !== 1 || o.name.indexOf(filter) !== -1);

    combobox.asyncResources$ = of(resources);
    combobox.loadingResources = false;
    this.flowDetails = undefined;
    this.combobox2IsDisabled = false;
    this.combobox2IsLoading = false;
  }

  ngOnDestroy = () => {
  }

  reloadData = () => {
    this.isLoading = true;
    this.failureMode = false;

    // const heatmapFlowsCombinationsObservable = this.netscopeService.getHeatmapFlowsCombinations();

    this.netscopeService.getLastInfrastructureVersion().subscribe((infrastructureVersionResponse: Response<any>) => {

      let infrastructureVersion;

      if (infrastructureVersionResponse instanceof Success) {
        infrastructureVersion = infrastructureVersionResponse.element;
      } else {
        this.failureMode = true;
        this.isLoading = false;
        return;
      }

      this.buildResourceUuidToObjectIndex(infrastructureVersion);

      const heatmapSourceResourcesObservable = this.netscopeService.heatmapGetSourceResources();

      heatmapSourceResourcesObservable.subscribe((heatmapSourcesResponse) => {

        if (heatmapSourcesResponse instanceof Failure) {
          this.failureMode = true;
          this.isLoading = false;
          return;
        }

        if (heatmapSourcesResponse instanceof Success) {
          this.heatmapSourceResources = heatmapSourcesResponse.element;
        }

        // this.buildResourceUuidToObjectIndex();
        this.isLoading = false;
        this.combobox1IsDisabled = false;
      });

      if (this.selectedResources1.length > 0 && this.selectedResources2.length > 0) {
        this.resourceSelectionChanged.emit({
          "update": true
        });
      }
    });

  }

  loadFlows = (timestamp, timeResolution) => {
    let srcUuid, dstUuid;
    for (let resource of this.selectedResources1) {
      srcUuid = resource.uuid;
    }
    for (let resource of this.selectedResources2) {
      dstUuid = resource.uuid;
    }

    if (srcUuid === undefined) {
      console.log(`could not fetch flows: one of src (${srcUuid}) or dst (${dstUuid}) is undefined`);
    } else {
      console.log(`loading flows for src (${srcUuid}) or dst (${dstUuid}) at timestamp ${timestamp}`);
      this.netscopeService.getHeatmapFlowsDetails(srcUuid, dstUuid, timestamp, timeResolution, this.directionMode).subscribe((flowDetailsResponse: Response<HeatmapFlowDetail>) => {

        let heatmapFlowsDetails;
        if (flowDetailsResponse instanceof Success) {
          heatmapFlowsDetails = flowDetailsResponse.element;
        }

        let countryMap: Map<string, CountryEntry> = new Map<string, CountryEntry>();
        for (let [country, countryCode] of heatmapFlowsDetails.countries) {
          countryMap.set(countryCode, {country: country, countryCode: countryCode})
        }

        // AsnMap
        let asnMap: Map<number, AsnEntry> = new Map<number, AsnEntry>();
        for (let [asn, asnNum] of heatmapFlowsDetails.asns) {
          asnMap.set(asnNum, {asn: asn, asnNum: asnNum});
        }

        let nodeMapping: Map<string, FlowRessourceObject> = new Map();
        this.flowDetails = NetscopeUtils.duckDbFlowsToFlowsDetails(heatmapFlowsDetails.flows, nodeMapping, countryMap, asnMap, new Map());

        let apiNodeMapping: Map<string, DuckDbResourceObject> = new Map(Object.entries(heatmapFlowsDetails.node_mapping));

        // Fix names in nodeMap
        for (let [key, value] of nodeMapping.entries()) {
          if (apiNodeMapping.has(key)) {
            value.name = apiNodeMapping.get(key).name;
          } else {
            value.name = value.address;
          }
        }

        // NetscopeUtils.fixFlowsWithNodesMappings(this.flowDetails, nodeMapping, apiNodeMapping)

        // this.sidePanelFlows = this.flowDetails;
        // this.sidePanelOpened = true;
        this.showSidePanel("Details of flows", this.flowDetails, "");
      });
    }
  }

  buildResourceUuidToObjectIndex = (infrastructureVersion: InfrastructureVersion) => {
    // Create index of UUID => resource
    for (let tuple2 of [
      ["vm", infrastructureVersion.topology.vm_only_topology.vms],
      ["host", infrastructureVersion.topology.vm_only_topology.hosts],
      ["external_ip", this.externalIps]
    ]) {
      let resourceType = tuple2[0];
      let resources = tuple2[1];

      if (resources === undefined) {
        continue;
      }

      for (let resource of resources) {
        let longUuid = `${resource.uuid}`;
        let shortUuid = longUuid.split(":")[1];

        if (resourceType === "external_ip") {
          resource.short_uuid = shortUuid;
          resource.uuid = longUuid;
        }

        let resourceObject = {
          "shortUuid": shortUuid,
          "uuid": longUuid,
          "name": resource.name,
          "resourceType": resourceType,
        };
        this.resourceUuidToObjectsIndex[longUuid] = resourceObject;
        this.resourceUuidToObjectsIndex[shortUuid] = resourceObject;
      }
    }
  }

  reloadUi = (category: string) => {
  }

  /**
   * This method export the config table into a CSV file
   */
  exportCSV() {
    let csvHeader = "Source, Destination, ExchangedBytes, TotalPackets"
    let csvContent = csvHeader + "\n";
    // for (let link of this.filteredLinks) {
    //   let lineValue = `${link.source.name}, ${link.target.name}, ${link.exchanged_bytes}, ${link.exchanged_packets}\n`;
    //   csvContent += lineValue;
    // }

    let exportedFilename = 'netscope-clusters.csv';
    let blob = new Blob([csvContent], {
      type: 'text/csv;charset=utf-8;'
    });
    // @ts-ignore
    if (navigator.msSaveBlob) { // IE 10+
      // @ts-ignore
      navigator.msSaveBlob(blob, exportedFilename);
    } else {
      let link = document.createElement("a");
      if (link.download !== undefined) { // feature detection
        // Browsers that support HTML5 download attribute
        let url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", exportedFilename);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
  }

  setLanguage = (language: "french" | "english") => {
    let languageMap: Map<string, string> = new Map([
      ["french", "fr"],
      ["english", "en"]
    ]);
    let language_code = languageMap.get(language);
    this.translocoService.setDefaultLang(language_code);
    this.translocoService.setActiveLang(language_code);
    localStorage.setItem("language", language_code);
  }

  switchFocus = (vm) => {
    this.sidePanelOpened = false;
    this.netscopeUiService.switchFocus(vm);
  }

  exportRowPerPortCSV = () => {
    let csvHeader = "Source, Destination, Port, Protocol, ExchangedBytes"
    let csvContent = csvHeader + "\n";
    for (let flow of this.sidePanelFlows) {
      let lineValue =
        `${flow.source.name}, ${flow.target.name}, ${flow.port}, ${flow.protocol}, ${flow.exchanged_bytes}\n`;
      csvContent += lineValue;
    }

    let exportedFilename = 'netscope-protocols.csv';
    let blob = new Blob([csvContent], {
      type: 'text/csv;charset=utf-8;'
    });
    if (navigator.msSaveBlob) { // IE 10+
      navigator.msSaveBlob(blob, exportedFilename);
    } else {
      let link = document.createElement("a");
      if (link.download !== undefined) { // feature detection
        // Browsers that support HTML5 download attribute
        let url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", exportedFilename);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
  }

  showSidePanel = (title: string, flowsDetails: FlowDetail[], resourceId: string=undefined) => {
    this.sidePanelTitle = title;
    let sidePanelFlows = NetscopeUtils.flowsDetailsToPerPortFlowDetails(flowsDetails);

    sidePanelFlows = sidePanelFlows.sort((fa, fb) => fb.exchanged_bytes - fa.exchanged_bytes);

    this.sidePanelFlows = sidePanelFlows;
    this.sidePanelResourceUuid = resourceId;

    // let currentFocusUuids = this.currentComboboxSelection
    //   .filter((s) => s.mode === "focus")
    //   .map((s) => s.resource.uuid);

    this.sidePanelIsAlreadyFocused = true;

    let insideFlows: FlowDetail[] = [];
    let outsideFlows: FlowDetail[] = [];

    for (let flowDetail of flowsDetails) {
      let isInsideFlow = true

      if ((flowDetail.source.type === "internet_ip") || (flowDetail.target.type === "internet_ip")) {
        isInsideFlow = false;
      }
      if (flowDetail.source.type === "asn" || flowDetail.target.type === "asn" ) {
        isInsideFlow = false;
      }

      if (isInsideFlow) {
        insideFlows.push(flowDetail);
      } else {
        outsideFlows.push(flowDetail);
      }
    }

    let insideFlowsExchangedBytes = insideFlows
      .map((flow) => flow.exchanged_bytes)
      .reduce((a, b) => a + b, 0);

    let outsideFlowsExchangedBytes = outsideFlows
      .map((flow) => flow.exchanged_bytes)
      .reduce((a, b) => a + b, 0);

    let originsData = [{
      name: "inside",
      value: insideFlowsExchangedBytes,
    }, {
      name: "outside",
      value: outsideFlowsExchangedBytes,
    }];

    let protocolsExchangedBytes: Map<string, number> = new Map<string, number>();
    for (let flowDetail of flowsDetails) {
      for (let metric of flowDetail.metrics.values()) {
        if (!protocolsExchangedBytes.has(metric.application_protocol)) {
          protocolsExchangedBytes.set(metric.application_protocol, 0);
        }
        protocolsExchangedBytes.set(metric.application_protocol, protocolsExchangedBytes.get(metric.application_protocol) + metric.exchanged_bytes);
      }
    }
    let protocolsData: {name: string, value: number}[] = [];
    for (let [protocol, exchangedBytes] of Array.from(protocolsExchangedBytes.entries())) {
      protocolsData.push({
        "name": protocol,
        "value": exchangedBytes
      });
    }

    // TODO: replace the following hard-coded value with something from css variables, like <lightModeTextColor>
    let darkModeTextColor = "white";
    let lightModeTextColor = this.style.getPropertyValue('--highcharts-neutral-color-100');

    let textColor = this.isDarkMode ? darkModeTextColor : lightModeTextColor;

    // Update pie charts
    this.sidePanelProtocolsOptions = {
      title: {
        text: "Protocols",
        textStyle: {
          color: textColor
        }
      },
      // legend: {},
      // height: 300,
      tooltip: {
        formatter: function (params) {
          return `
            ${params.marker} ${params.name}: ${NetscopeUtils.formatBytes(params.value)} (${params.percent}%)
          `;
        }
      },
      series: [{
        type: 'pie',
        data: protocolsData,
        label: {
          color: textColor,
          textBorderWidth: 0,
        }
      }],
    };

    this.sidePanelOriginsOptions = {
      title: {
        text: "Origin",
        textStyle: {
          color: textColor
        }
      },
      // legend: {},
      type: "pie",
      // height: 300,
      tooltip: {
        formatter: function (params) {
          return `
            ${params.marker} ${params.name}: ${NetscopeUtils.formatBytes(params.value)} (${params.percent}%)
          `;
        }
      },
      series: [{
        type: 'pie',
        data: originsData,
        label: {
          color: textColor,
          textBorderWidth: 0,
        }
      }],
    };

    this.sidePanelOpened = true;
  }

  heatmapDetailLevelChanged = () => {
    this.resourceSelectionChanged.emit({
      "reloadData": false,
      "temporalResolution": this.timeResolutionRadioButtonValue
    });
  }
}

